var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFlexCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    "aria-label": "Flex Card",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1666 8.47949H1.83331C1.45748 8.47949 1.14581 8.16783 1.14581 7.79199C1.14581 7.41616 1.45748 7.10449 1.83331 7.10449H20.1666C20.5425 7.10449 20.8541 7.41616 20.8541 7.79199C20.8541 8.16783 20.5425 8.47949 20.1666 8.47949Z",
    fill: "#525252"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 15.8125H5.5C5.12417 15.8125 4.8125 15.5008 4.8125 15.125C4.8125 14.7492 5.12417 14.4375 5.5 14.4375H7.33333C7.70917 14.4375 8.02083 14.7492 8.02083 15.125C8.02083 15.5008 7.70917 15.8125 7.33333 15.8125Z",
    fill: "#525252"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2917 15.8125H9.625C9.24917 15.8125 8.9375 15.5008 8.9375 15.125C8.9375 14.7492 9.24917 14.4375 9.625 14.4375H13.2917C13.6675 14.4375 13.9792 14.7492 13.9792 15.125C13.9792 15.5008 13.6675 15.8125 13.2917 15.8125Z",
    fill: "#525252"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0966 19.4788H5.90331C2.25498 19.4788 1.14581 18.3788 1.14581 14.7672V7.23217C1.14581 3.62051 2.25498 2.52051 5.90331 2.52051H16.0875C19.7358 2.52051 20.845 3.62051 20.845 7.23217V14.758C20.8541 18.3788 19.745 19.4788 16.0966 19.4788ZM5.90331 3.89551C3.02498 3.89551 2.52081 4.39051 2.52081 7.23217V14.758C2.52081 17.5997 3.02498 18.0947 5.90331 18.0947H16.0875C18.9658 18.0947 19.47 17.5997 19.47 14.758V7.23217C19.47 4.39051 18.9658 3.89551 16.0875 3.89551H5.90331Z",
    fill: "#525252"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlexCard);
export default __webpack_public_path__ + "static/media/flex-card.91dc731e379fe95695ae74e2f1b67f41.svg";
export { ForwardRef as ReactComponent };